import { Controller } from "@hotwired/stimulus"

const EXCLUSIVE_REPLY_OPTIONS = new Set([
  "everyone_can_reply",
  "no_reply"
])
const DEFAULT_REPLY_OPTION = "everyone_can_reply"

export default class DropdownController extends Controller {

  connect() {
    this.updateReplyOptionDisplay()

    this.boundHandleShow = this.handleShow.bind(this)
    document.addEventListener("show.bs.dropdown", this.boundHandleShow)
  }

  disconnect() {
    document.removeEventListener("show.bs.dropdown", this.boundHandleShow)
  }

  handleShow(event) {
    const targetDropdown = event.target.closest(".dropdown")
    const targetDropdownMenu = targetDropdown.querySelector(".dropdown-menu");
    const targetToggle = event.target.querySelector('[data-bs-toggle="dropdown"]');

    // Manage single-open dropdown state across comments and posts sections
    for (const dropdown of document.querySelectorAll("#updated_comment_list .dropdown, .group-posts .dropdown")) {
      const dropdownToggle = dropdown.querySelector(':scope > [data-bs-toggle="dropdown"]');
      const dropdownMenu = dropdown.querySelector(".dropdown-menu");
      const isTarget = dropdownMenu === targetDropdownMenu;
      if (!isTarget && dropdownToggle && dropdownMenu.classList.contains("show")) {
        bootstrap.Dropdown.getOrCreateInstance(dropdownToggle).toggle();
      }

      if (isTarget && targetToggle && !dropdownMenu.classList.contains("show")) {
        bootstrap.Dropdown.getOrCreateInstance(targetToggle).toggle();
      }
    }
  }

  reply_option(event) {
    const target = event.currentTarget
    const nestedForm = this.element.closest('[data-controller="nested-form"]')

    if (nestedForm) {
      nestedForm.querySelectorAll(".reply-opt-select").forEach(group => {
        const options = Array.from(group.querySelectorAll(".form-check-input"))

        const currentOption = options.find(
          option => option.value === target.value
        )

        if (!currentOption) return

        // mirror checked/unchecked state
        currentOption.checked = target.checked

        this.applyReplyOptionRules(currentOption, options)
        this.updateReplyOptionDisplay(options, group.closest('[data-controller="dropdown"]'))
      })

      return
    }

    this.applyReplyOptionRules(target, this.replyOptions)
    this.updateReplyOptionDisplay()
  }

  get replyOptions() {
    return Array.from(
      this.element.querySelectorAll(
        ".reply-opt-select .form-check-input"
      )
    )
  }

  updateReplyOptionDisplay(options = this.replyOptions, container = this.element) {
    const selectedLabels = options
      .filter(option => option.checked)
      .map(option => option.nextElementSibling.textContent.trim())

    const display = container.querySelector(".selected-value-display")

    if (display) {
      display.textContent =
        selectedLabels.join(", ") || "Select Reply Options"
    }
  }

  applyReplyOptionRules(target, options) {
    if (target.checked && EXCLUSIVE_REPLY_OPTIONS.has(target.value)) {
      options.forEach(option => {
        option.checked = option === target
      })
    } else if (target.checked) {
      options.forEach(option => {
        if (EXCLUSIVE_REPLY_OPTIONS.has(option.value)) {
          option.checked = false
        }
      })
    }

    if (!options.some(option => option.checked)) {
      const defaultOption = options.find(
        option => option.value === DEFAULT_REPLY_OPTION
      )

      if (defaultOption) defaultOption.checked = true
    }
  }
}
